import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useInView } from 'react-intersection-observer';
import { getRelatedContentReady } from '../../../DeviationPage/redux/selectors';
import { fetchRelatedContentForDeviation } from '../../../DeviationPage/redux/actions';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
/**
 * Handles the lazy loading of the related content for the devpage.
 *
 * This component should be key'd by deviationId so inView doesn't cache between views.
 *
 * Logic on backend:
 *  - Mobile only load related by request via expand deviation.related
 *  - Desktop load all the time
 *
 * see API::should_expand_related_content
 *
 * Logic on frontend:
 *  - Mobile load related only when the user scrolls near (300px) to the sidebar
 *  - Desktop load all the time but skip when we think a non-preload request is
 *    happening that will include the related content anyway.
 *
 */ const SidebarInviewSentinal = ({ isDesktop, deviation })=>{
    const dispatch = useDispatch();
    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '0px',
        threshold: 0
    });
    const relatedLoaded = useSelector((state)=>getRelatedContentReady(state, deviation));
    const isLazyRelated = useFlag('lazy_related');
    // Request load related once we are inView
    useEffect(()=>{
        if (inView && !relatedLoaded && isLazyRelated) {
            dispatch(fetchRelatedContentForDeviation(deviation, isDesktop));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inView,
        dispatch,
        isDesktop,
        deviation.deviationId
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        style: {
            height: '1px'
        }
    });
};
SidebarInviewSentinal.displayName = 'SidebarInviewSentinal';
export default SidebarInviewSentinal;
